import { Parcel } from "../../../../services/parcelTypes";
import { formatNumber } from "../../../../utils/parcelFormatters";
import { Field } from "../ParcelFields";
import { ParcelSection } from "../ParcelSection";

export function ParcelSiteInfoSection({
    parcel,
}: {
    parcel: Parcel;
}) {
    return (
        <ParcelSection
            title="Site Information"
            columns={3}
            icon={
                <svg fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
                </svg>
            }
            collapsible
            defaultExpanded={false}
        >
            <Field label="Lot Sqft" value={formatNumber(parcel.site?.lot?.sqft)} />
            <Field label="Lot Acres" value={parcel.site?.lot?.acres?.toFixed(2) ?? "—"} />
            <Field label="Residential Buildings" value={formatNumber(parcel.site?.counts?.residential)} />
            <Field label="Commercial Buildings" value={formatNumber(parcel.site?.counts?.commercial)} />
            <Field label="Commercial Gross Sqft" value={formatNumber(parcel.site?.areaSqft?.commercialGross)} />
            <Field label="Commercial Net Sqft" value={formatNumber(parcel.site?.areaSqft?.commercialNet)} />
            <Field label="New Construction" value={parcel.site?.isNewConstruction === true ? "Yes" : parcel.site?.isNewConstruction === false ? "No" : "—"} />
        </ParcelSection>
    );
}